function animateMarquee(element) {
  let x = 0;
  // Infer speed from length of the string in element and apply to the animation
  const duration = element.innerText.length;

  function step() {
    x -= 5 / duration;

    // Reset position if it's moved out of view
    if (x < -100) {
      x = 0;
    }

    // Apply the transformation
    element.style.transform = `translateX(${x}%)`;

    // Request the next frame
    requestAnimationFrame(step);
  }

  // Start the animation
  requestAnimationFrame(step);
}
// Animate the marquee at a speed of 1% per frame
const marquees = document.querySelectorAll('[data-marquee]');
marquees.forEach((el) => animateMarquee(el));
